/**
 * @description 表格图表
 */
import React from 'react'
import { Table } from 'antd'
import type { TableColumnsType } from 'antd'
interface Props {
  option: {
    dataset: {
      source: any[]
    }
  }
}

export default function SimpleTable(props: Props) {
  let columns: TableColumnsType<any> = []
  if (props.option.dataset.source.length > 0) {
    const firstRow = props.option.dataset.source[0]
    const columnNames = Object.keys(firstRow)
    columns = columnNames.map((name, index) => ({
      title: name,
      dataIndex: name,
      key: index,
      ellipsis: true,
      render: (text: string) => {
        if (name === 'ip') {
          return (
            <div className="max-w-[120px] truncate" title={text}>
              {text}
            </div>
          )
        } else {
          return text
        }
      },
    }))
    console.log('columns', columns)
  }

  const data = props.option.dataset.source

  return (
    <div className="simple-table flex max-w-full flex-row justify-between">
      <Table
        columns={columns}
        dataSource={data}
        size="small"
        rowKey="id"
        pagination={false}
        scroll={{ x: true, y: 225 }}
      />
    </div>
  )
}
